import { useActivation } from '@context/MobileOne';
import { FeedbackImage, ScrollToTop } from '@core/index';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import useCmsImage from '@utils/useCmsImage';

export function TariffSuccess() {
  const {
    tariffActivationForm,
    setShowActivationHeader,
    tariffActivationFormSubmit,
    setStep2SubStep
  } = useActivation();

  // Const
  const imageContent = useCmsImage('ek_reg_tariff_suc_upsell_web_bg');
  const headerContent = tA11y('ek_reg_tariff_suc_upsell_hdl1');
  const copyTextContent = tA11y('ek_reg_tariff_suc_upsell_txt1');
  const buttonContent = tA11y('ek_reg_tariff_suc_upsell_btn1');

  return (
    <>
      <ScrollToTop>
        <FeedbackImage
          image={imageContent}
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          icon={appIconsPath.CELEBRATE}
          buttonType={appButtonType.PRIMARY}
          buttonIcon={appIconsPath.ARROW_RIGHT}
          buttonClick={() => {
            setStep2SubStep(0);
            tariffActivationFormSubmit(tariffActivationForm);
            setShowActivationHeader(true);
          }}
        />
      </ScrollToTop>
    </>
  );
}

export default TariffSuccess;
